import { jsx as _jsx } from "react/jsx-runtime";
import { BLUE_500, Button, DynamicSvg, InfoTag, Radio, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { Image, Pressable, View } from 'react-native';
import { getSectionTitleWidgetStyles } from '../../SectionTitleWidgetStyles';
import { SnapIndicator } from '../snap-indicator';
export var SectionTitleActions = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'SectionTitleActions' : _props$testID,
    actionCtaText = props.actionCtaText,
    actionCtaIconName = props.actionCtaIconName,
    actionCtaOnPress = props.actionCtaOnPress,
    onUserAction = props.onUserAction,
    infoTagProps = props.infoTagProps,
    isActionIconPressable = props.isActionIconPressable,
    onActionIconPress = props.onActionIconPress,
    actionTypes = props.actionTypes,
    actionIconName = props.actionIconName,
    actionImageUrl = props.actionImageUrl,
    actionImageStyles = props.actionImageStyles,
    color = props.color,
    actionUnicodeString = props.actionUnicodeString,
    actionUnicodeStyles = props.actionUnicodeStyles,
    radioButtonProps = props.radioButtonProps,
    onRadioButtonPressMetaData = props.onRadioButtonPressMetaData,
    id = props.id;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var sectionTitleWidgetStyles = getSectionTitleWidgetStyles();
  var ActionIconComponent = () => {
    return _jsx(View, {
      children: _jsx(DynamicSvg, Object.assign({
        iconName: actionIconName,
        fontSize: isSmallScreen ? 16 : 20,
        color: isActionIconPressable ? BLUE_500 : color
      }, getTestId(testID, actionIconName)))
    });
  };
  var ImageComponent = () => {
    return _jsx(Image, Object.assign({
      source: {
        uri: actionImageUrl,
        height: 16,
        width: 16
      },
      style: actionImageStyles,
      resizeMode: "contain"
    }, getTestId(testID, 'imageUrl')));
  };
  function unicodeToChar(text) {
    if (!text) {
      return '';
    }
    var splited = text.split(' ');
    var str = '';
    for (var i = 0; i < splited.length; i++) {
      splited[i] = splited[i].replace('U', '0');
      splited[i] = splited[i].replace('+', 'x');
      str += String.fromCodePoint(parseInt(splited[i], 16));
    }
    return str;
  }
  var withPressable = component => {
    return _jsx(Pressable, Object.assign({
      onPress: onActionIconPress
    }, {
      children: component
    }));
  };
  var renderComponent = () => {
    switch (actionTypes) {
      case 'cta':
        return actionCtaText && _jsx(Button, Object.assign({
          buttonType: "tertiary",
          iconPosition: "right",
          title: actionCtaText,
          size: isSmallScreen ? 'sm' : 'md',
          iconName: actionCtaIconName,
          onPress: () => {
            isValidObject(actionCtaOnPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, actionCtaOnPress), props));
          }
        }, getTestId(testID, 'actionCta')));
      case 'icon':
        return actionIconName && (isActionIconPressable ? withPressable(_jsx(ActionIconComponent, {})) : _jsx(ActionIconComponent, {}));
      case 'info':
        return isValidObject(infoTagProps) && (isActionIconPressable ? withPressable(_jsx(InfoTag, Object.assign({}, infoTagProps, getTestId(testID, 'infoTag')))) : _jsx(InfoTag, Object.assign({}, infoTagProps, getTestId(testID, 'infoTag'))));
      case 'carousel-indicator':
        return _jsx(SnapIndicator, Object.assign({}, props === null || props === void 0 ? void 0 : props.carouselIndicatorProps));
      case 'image':
        return actionImageUrl && (isActionIconPressable ? withPressable(_jsx(ImageComponent, {})) : _jsx(ImageComponent, {}));
      case 'unicode':
        return actionUnicodeString && withPressable(_jsx(Typography, Object.assign({
          type: "body-para-sm",
          text: unicodeToChar(actionUnicodeString)
        }, getTestId(testID, 'heading'), {
          style: Object.assign(Object.assign({}, sectionTitleWidgetStyles.unicodeTextStyle), actionUnicodeStyles)
        })));
      case 'radio':
        return _jsx(Radio, Object.assign({
          onPress: data => isValidObject(onRadioButtonPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onRadioButtonPressMetaData), data)),
          accessibilityHint: ((radioButtonProps === null || radioButtonProps === void 0 ? void 0 : radioButtonProps.checked) ? 'selected ' : 'unselected ') + ((radioButtonProps === null || radioButtonProps === void 0 ? void 0 : radioButtonProps.accessibilityHint) || '')
        }, radioButtonProps, getTestId(testID, 'radio')));
      case 'none':
      default:
        return null;
    }
  };
  return _jsx(View, Object.assign({
    style: sectionTitleWidgetStyles.actionsContainer
  }, getTestId(testID, 'actionsContainer'), {
    children: renderComponent()
  }));
};